const baseColors = {
  primary: '#2563EB',
  primaryHover: '#1D4ED8',
  pageBackground: '#E5E5E5',
  surface: '#FFFFFF',
  textPrimary: '#1A1C21',
  textSecondary: '#343741',
  borderSubtle: '#D3DAE6',
  success: '#4CAF50',
  error: '#DC2626',
  warning: '#FFC107',
  secondaryContainer: '#DBEAFE',
  onSecondaryContainer: '#1E3A8A'
}

export const colors = new Proxy(baseColors, {
  get (target, prop) {
    if (prop in target) {
      return target[prop]
    }

    // Allow React/internal symbols safely
    if (typeof prop !== 'string' || prop === '$$typeof') {
      return target[prop]
    }

    // Explicit failure for development/testing
    throw new Error(`[Design System Error] Intento de acceso a token de color inexistente: '${prop}'. Usa exclusivamente los permitidos.`)
  }
})

export const derivedColors = {
  disabledBackground: '#e5e7eb',
  disabledText: '#737373',
  attenuated: '#8f8f8f',
  subtleSurface: '#F5F7FA',
  transparentSecondary: 'rgba(37, 99, 235, 0.2)',
  transparentSecondaryHover: 'rgba(37, 99, 235, 0.28)',
  errorHover: '#B91C1C',
  primaryFocusShadow: 'rgba(37, 99, 235, 0.2)'
}
